import { Outlet } from "react-router-dom";

const AdminPageLayout = () => {
  return (
    <><Outlet /></>
  );
};

export default AdminPageLayout;